import { render, staticRenderFns } from "./inspectionProofList.vue?vue&type=template&id=a125f454"
import script from "./inspectionProofList.vue?vue&type=script&lang=js"
export * from "./inspectionProofList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports